import Articles from "@/components/blog/articles";
import Header from "@/components/header";
import Footer from "@/components/home/footer";
import Seo from "@/components/seo";
import { fetchStrapiApi } from "@utils/fetchStrapiApi";
import { getStrapiMedia } from "@utils/getStrapiMedia";
import Image from "next/image";

const Author = ({ author }) => {
  // console.log(author);

  return (
    <>
      <Seo title={`${author.name} | Pinto Financial`} description={author.bio} />
      <div>
        <Header />
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-between px-4 sm:px-6 my-8">
          <div className="w-full overflow-hidden rounded-lg bg-white border p-8 mt-5 sm:py-16 sm:px-8">
            <div className="bg-white">
              <div className="flex sm:space-x-5 justify-center">
                <div className="flex-shrink-0">
                  <Image
                    width={124}
                    height={124}
                    className="h-24 w-24 sm:h-36 sm:w-36 rounded-full"
                    src={getStrapiMedia(author.picture)}
                    alt=""
                    unoptimized
                  />
                </div>
                <div className="ml-4">
                  <div className="flex flex-col items-start justify-between mb-2 sm:items-center sm:flex-row">
                    <h1 className="text-xl font-semibold text-gray-900 sm:text-2xl">{author.name}</h1>
                    <a href={author.twitter_link} className="mt-3 sm:mt-0" target="_blank" rel="noreferrer">
                      <svg fill="#1da1f2" viewBox="0 0 24 24" width="24" height="24">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                      </svg>
                    </a>
                  </div>
                  <p className="max-w-3xl text-base font-normal text-gray-600 mt-8 -ml-20 sm:ml-0 sm:mt-0">{author.bio}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="my-16 text-2xl font-semibold">
            <h2 className="mb-16 text-center">Articles by {author.name}</h2>
            <Articles articles={author.articles.data} />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Author;

export async function getStaticPaths() {
  const authorsRes = await fetchStrapiApi("/writers");
  // console.log(authorsRes.data);
  return {
    paths: authorsRes.data.map((author) => ({
      params: {
        slug: author.attributes.slug,
      },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const authorsRes = await fetchStrapiApi("/writers", {
    filters: {
      slug: params.slug,
    },
    populate: "*",
  });
  //   console.log(authorsRes.data[0].attributes);

  return {
    props: {
      author: authorsRes.data[0].attributes,
    },
    revalidate: 1,
  };
}
